import React from "react";
import HeroSection from "../components/HeroSection";
import BenefitsRow from "../components/BenefitsRow";
import OpenPositionsSection from "../components/OpenPositionsSection";
import SendResumeCTA from "../components/SendResumeCTA";

const CareersPage = () => {
  return (
    <main className="min-h-screen w-full bg-white">
      <HeroSection />
      <BenefitsRow />
      <OpenPositionsSection />
      <SendResumeCTA />
    </main>
  );
};

export default CareersPage;
